"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var _1 = require(".");
var form_action_1 = require("./form-action");
exports.defaultValues = {
    name: '',
    disabled: false,
    immutableCondition: null,
    conditionActionsList: immutable_1.List([]),
    preConditionActionsList: immutable_1.List([]),
};
/** factory that generates an immutable [[IFormRuleRecord]] */
exports.FormRuleRecord = immutable_1.Record(exports.defaultValues);
/** class that represents an immutable Form Rule */
var ImmutableFormRule = /** @class */ (function (_super) {
    __extends(ImmutableFormRule, _super);
    function ImmutableFormRule(props) {
        var _this = _super.call(this, __assign({}, props, { immutableCondition: _1.convertConditionToImmutable(props.condition), conditionActionsList: immutable_1.List(props.conditionActions ? props.conditionActions.map(function (action) { return new form_action_1.ImmutableFormAction(action); }) : []), preConditionActionsList: immutable_1.List(!!props.preConditionActions ? props.preConditionActions.map(function (action) { return new form_action_1.ImmutableFormAction(action); }) : []) })) || this;
        _this.condition = _this.immutableCondition && _this.immutableCondition.toObject();
        _this.conditionActions = _this.conditionActionsList && _this.conditionActionsList.toArray();
        _this.preConditionActions = _this.preConditionActionsList && _this.preConditionActionsList.toArray();
        return _this;
    }
    /**
     * creates a clone of the current [[ImmutableFormRule]]
     * @param key property to change
     * @param value value that the property will be set to
     */
    ImmutableFormRule.prototype.set = function (key, value) {
        var result = _super.prototype.set.call(this, key, value);
        var object = result.toObject();
        return new ImmutableFormRule(object);
    };
    /** makes sure that converting this to an object includes properties exclusive to [[IFormRule]] */
    ImmutableFormRule.prototype.toObject = function () {
        var object = _super.prototype.toObject.call(this);
        var immutableActions = object.conditionActionsList.toArray();
        var immutablePreConditionActions = object.preConditionActionsList.toArray();
        return __assign({}, object, { condition: object.immutableCondition && object.immutableCondition.toObject(), conditionActions: immutableActions && immutableActions.map(function (val) { return val.toObject(); }), preConditionActions: immutablePreConditionActions && immutablePreConditionActions.map(function (val) { return val.toObject(); }) });
    };
    return ImmutableFormRule;
}(exports.FormRuleRecord));
exports.ImmutableFormRule = ImmutableFormRule;
//# sourceMappingURL=form-rule.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/form-rule.js
// module id = 1117
// module chunks = 0